import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import * as Styled from './styles/LandingPageHero.styles'
import {
  HeroGraphicDisease,
  HeroGraphicCommunity,
  HeroGraphicFoundation,
  HeroGraphicAdvance,
  HeroGraphicResearch,
} from '../Icons'
import CtaLink from '../ContentBlocks/CtaLink'
import TableOfContentsDropdown from './TableOfContentsDropdown'
import { PrismicRichText } from '@prismicio/react'

const navQuery = graphql`
  {
    prismicNavigationMenu {
      id
      type
      data {
        body {
          ... on PrismicNavigationMenuDataBodySection {
            id
            slice_label
            slice_type
            primary {
              external_link_text
              parent {
                uid
                type
                link_type
                id
                url
                document {
                  ... on PrismicLandingPage {
                    data {
                      page_title {
                        text
                      }
                    }
                  }
                  ... on PrismicAdvanceLandingPage {
                    data {
                      page_title {
                        text
                      }
                    }
                  }
                }
              }
            }
            items {
              external_link_text
              subpage {
                uid
                type
                link_type
                id
                url
                document {
                  ... on PrismicSubpage {
                    data {
                      title {
                        text
                      }
                    }
                  }
                  ... on PrismicCmeMediaLibraryPage {
                    data {
                      title {
                        text
                      }
                    }
                  }
                  ... on PrismicMediaLibraryPage {
                    data {
                      title {
                        text
                      }
                    }
                  }
                  ... on PrismicHcpdLandingPage {
                    data {
                      title {
                        text
                      }
                    }
                  }
                  ... on PrismicProductLandingPage {
                    data {
                      title {
                        text
                      }
                    }
                  }
                  ... on PrismicAudienceCampaignPage {
                    data {
                      title: hero_text {
                        text
                      }
                    }
                  }
                  ... on PrismicMediaLibraryItem {
                    data {
                      title {
                        text
                      }
                    }
                  }
                  ... on PrismicHcpdNewRegistrationPage {
                    data {
                      title {
                        text
                      }
                    }
                  }
                  ... on PrismicAdvanceArticle {
                    data {
                      title: header {
                        text
                      }
                    }
                  }
                  ... on PrismicStaffBoardLandingPage {
                    data {
                      title {
                        text
                      }
                    }
                  }
                  ... on PrismicNpfAuthor {
                    data {
                      title: name {
                        text
                      }
                    }
                  }
                  ... on PrismicEventsLandingPage {
                    data {
                      title {
                        text
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

const LandingPageHero = ({
  pageTitle,
  heroText,
  heroImage,
  heroGraphic,
  uid,
  halfHeight = false,
  includeCta = false,
  ctaLink = null,
  ctaText = null,
}) => (
  <StaticQuery
    query={navQuery}
    render={data => {
      const section = data.prismicNavigationMenu.data.body
        .filter(body => body.primary.parent.uid === uid)
        .slice(0, 1)
        .pop()

      const options = section
        ? section.items.filter(item => {
            if (item.subpage?.uid) {
              return item
            }
          })
        : []

      const filteredOptions = options.map(item => {
        const obj =
          item.subpage.uid == 'new-registration'
            ? {
                value: 'health-care-provider-directory/' + item.subpage.uid,
                label: item.subpage.document.data.title.text,
              }
            : {
                value: item.subpage.uid,
                label: item.subpage.document.data.title.text,
              }
        return obj
      })

      const includeTableOfContents = options.length > 0

      return (
        <Styled.LandingPageHero
          halfHeight={halfHeight}
          includeTableOfContents={includeTableOfContents}
        >
          <Styled.HeroGraphicContainer>
            {
              {
                'Disease / Treatment': <HeroGraphicDisease />,
                'Community / Support': <HeroGraphicCommunity />,
                'Foundation / About Us': <HeroGraphicFoundation />,
                'Research / Medical': <HeroGraphicResearch />,
                'Advance Online': <HeroGraphicAdvance />,
              }[heroGraphic]
            }
          </Styled.HeroGraphicContainer>
          {heroImage?.url && (
            <Styled.HeroImage src={heroImage.url} alt={heroImage.alt} />
          )}
          {includeTableOfContents && (
            <TableOfContentsDropdown filteredOptions={filteredOptions} />
          )}
          <Styled.TextRegion>
            <Styled.PageTitle>{pageTitle}</Styled.PageTitle>
            <Styled.HeroText>
              <PrismicRichText field={heroText.richText} />
            </Styled.HeroText>
            {includeCta && ctaLink && ctaText && (
              <CtaLink text={ctaText} link={ctaLink} />
            )}
          </Styled.TextRegion>
        </Styled.LandingPageHero>
      )
    }}
  />
)

export default LandingPageHero
